'use client';

import { c as _c } from "react/compiler-runtime";
import { Spinner } from '@common/components';
import { QueryErrorResetBoundary } from '@tanstack/react-query';
import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorFallback } from './Error';
interface QuerySuspenseErrorBoundaryProps {
  children: React.ReactNode;
  suspenseFallback?: React.ReactNode | string;
  errorFallback?: ({
    error,
    resetErrorBoundary
  }: {
    error: Error;
    resetErrorBoundary: VoidFunction;
  }) => React.ReactNode;
}
export const QuerySuspenseErrorBoundary = t0 => {
  const $ = _c(4);
  const {
    children,
    suspenseFallback,
    errorFallback
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== errorFallback || $[2] !== suspenseFallback) {
    t1 = <QueryErrorResetBoundary>{t2 => {
        const {
          reset
        } = t2;
        return <ErrorBoundary fallbackRender={t3 => {
          const {
            resetErrorBoundary,
            error
          } = t3;
          return errorFallback ? errorFallback({
            error,
            resetErrorBoundary
          }) : <ErrorFallback error={error} reset={resetErrorBoundary} />;
        }} onReset={reset}><Suspense fallback={suspenseFallback || <Spinner />}>{children}</Suspense></ErrorBoundary>;
      }}</QueryErrorResetBoundary>;
    $[0] = children;
    $[1] = errorFallback;
    $[2] = suspenseFallback;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};